import styled from 'styled-components';
import ListItemCompoment from '@prisjakt/ui-list-item';

// eslint-disable-next-line import/prefer-default-export
export const ListItem = styled(ListItemCompoment)({
  '&&': {
    img: {
      marginRight: '10px',
    },
  },
});
